/* ============================================================
   The Ladies — Tirzepatida PDP
   tirzepatida-pdp.js
   ============================================================ */
(function () {
  'use strict';

  /* ── Gallery ─────────────────────────────────────────────── */
  /* Descricao: ver mais / ver menos */
  const desc = document.querySelector('[data-tirz-desc]');
  if (desc) {
    const body      = desc.querySelector('[data-tirz-desc-body]');
    const toggle    = desc.querySelector('[data-tirz-desc-toggle]');
    const COLLAPSED = 96;

    if (body && toggle) {
      // scrollHeight ignora o max-height, entao mede a altura real do conteudo
      if (body.scrollHeight <= COLLAPSED + 8) {
        // Descricao curta: mostra inteira e dispensa o botao
        desc.dataset.collapsed = 'false';
      } else {
        toggle.hidden = false;
        toggle.addEventListener('click', function () {
          const isCollapsed = desc.dataset.collapsed === 'true';
          desc.dataset.collapsed = isCollapsed ? 'false' : 'true';
          toggle.setAttribute('aria-expanded', String(isCollapsed));
          toggle.textContent = isCollapsed ? 'Ver menos' : 'Ver mais';
        });
      }
    }
  }

  const gallery = document.getElementById('tirz-gallery');
  if (gallery) {
    const thumbs = gallery.querySelectorAll('.tirz-gallery__thumb');
    const imgs   = gallery.querySelectorAll('.tirz-gallery__img');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx = parseInt(thumb.dataset.index, 10);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        imgs.forEach(function (i)   { i.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (imgs[idx]) imgs[idx].classList.add('is-active');
      });
    });
  }

  /* ── Variant selector + price update ─────────────────────── */
  const variantList = document.getElementById('tirz-variants');
  if (variantList) {
    const variantLabels  = variantList.querySelectorAll('.tirz-variant');
    const variantIdInput = document.getElementById(variantList.dataset.variantInput);
    const installmentEl = document.getElementById('tirz-installment');

    function formatBRL(cents) {
      return 'R$ ' + (cents / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }

    function updatePrice(priceCents) {
      const installment = Math.round(priceCents / 10);
      if (installmentEl) installmentEl.textContent = '10× ' + formatBRL(installment);
    }

    variantLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        variantLabels.forEach(function (l) { l.classList.remove('is-selected'); });
        label.classList.add('is-selected');
        const price = parseInt(label.dataset.price, 10);
        updatePrice(price);
        if (variantIdInput) {
          variantIdInput.value = label.dataset.variantId;
        }
        // Quando o CTA e um link de checkout externo, acompanha a variante
        const ctaEl = document.getElementById('tirz-atc-btn');
        if (ctaEl && ctaEl.tagName === 'A' && label.dataset.ctaUrl) {
          ctaEl.href = label.dataset.ctaUrl;
        }
      });
    });
  }

  /* ── Mini Cart Drawer (próprio, não depende do drawer nativo do tema) ── */
  var TL_FREE_SHIP = 15000; // R$ 150,00 em centavos

  function tlFmt(cents) {
    return 'R$ ' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function tlUpsellData() {
    var el = document.getElementById('tirz-upsell-data');
    if (!el) return null;
    return {
      title:     el.dataset.title     || '',
      image:     el.dataset.image     || '',
      price:     parseInt(el.dataset.price, 10)     || 0,
      variantId: parseInt(el.dataset.variantId, 10) || 0
    };
  }

  function tlInitDrawer() {
    if (document.getElementById('tl-cart-overlay')) return;

    var css = document.createElement('style');
    css.textContent = [
      '#tl-cart-overlay{display:none;position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,.45)}',
      '#tl-cart-overlay.is-open{display:block}',
      '#tl-cart-panel{position:fixed;top:0;right:0;bottom:0;width:min(420px,100vw);background:#fff;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .35s cubic-bezier(.4,0,.2,1);box-shadow:-6px 0 32px rgba(0,0,0,.18)}',
      '#tl-cart-overlay.is-open #tl-cart-panel{transform:translateX(0)}',
      '.tl-ch{display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid #e8e8e8;flex-shrink:0}',
      '.tl-ch span{font-size:16px;font-weight:700;letter-spacing:.04em;text-transform:uppercase}',
      '.tl-ch button{background:none;border:none;cursor:pointer;font-size:24px;line-height:1;color:#555;padding:2px 6px}',
      '.tl-ship{padding:16px 24px 14px;background:#f6fbf7;border-bottom:1px solid #e4f0e8;flex-shrink:0}',
      '.tl-ship-text{font-size:13px;color:#444;margin-bottom:10px;text-align:center;line-height:1.5}',
      '.tl-ship-text strong{color:#1a7a3c;font-weight:700}',
      '.tl-ship-bar{height:6px;background:#d8eede;border-radius:3px;overflow:hidden}',
      '.tl-ship-fill{height:100%;background:#1a7a3c;border-radius:3px;transition:width .5s ease}',
      '.tl-ci{flex:1;overflow-y:auto;padding:0 24px}',
      '.tl-item{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #f2f2f2}',
      '.tl-item img{width:76px;height:76px;object-fit:cover;border-radius:6px;background:#f5f5f5;flex-shrink:0}',
      '.tl-iinfo{flex:1;min-width:0}',
      '.tl-ititle{font-size:13px;font-weight:600;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.tl-ivar{font-size:12px;color:#888;margin-bottom:8px}',
      '.tl-irow{display:flex;align-items:center;justify-content:space-between;margin-top:8px}',
      '.tl-qty{display:flex;align-items:center;border:1px solid #e0e0e0;border-radius:4px;overflow:hidden}',
      '.tl-qty button{background:none;border:none;cursor:pointer;padding:5px 10px;font-size:15px;color:#333;line-height:1}',
      '.tl-qty button:hover{background:#f5f5f5}',
      '.tl-qty span{font-size:13px;min-width:24px;text-align:center}',
      '.tl-iprice{font-size:14px;font-weight:700}',
      '.tl-remove{background:none;border:none;cursor:pointer;color:#ccc;font-size:18px;padding:4px;line-height:1;margin-left:4px}',
      '.tl-remove:hover{color:#e74c3c}',
      '.tl-upsell{padding:14px 24px;background:#f9f9f9;border-top:1px solid #efefef;flex-shrink:0}',
      '.tl-upsell-lbl{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#999;margin-bottom:10px}',
      '.tl-upsell-card{display:flex;gap:12px;align-items:center}',
      '.tl-upsell-card img{width:60px;height:60px;object-fit:cover;border-radius:6px;background:#eee;flex-shrink:0}',
      '.tl-upsell-info{flex:1;min-width:0}',
      '.tl-upsell-title{font-size:13px;font-weight:600;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.tl-upsell-price{font-size:12px;color:#888}',
      '.tl-upsell-btn{flex-shrink:0;background:#0f1117;color:#fff;border:none;border-radius:4px;padding:8px 14px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap}',
      '.tl-upsell-btn:disabled{opacity:.5;cursor:default}',
      '.tl-discount{padding:14px 24px;border-top:1px solid #efefef;flex-shrink:0}',
      '.tl-discount-toggle{background:none;border:none;cursor:pointer;color:#555;font-size:13px;font-weight:600;padding:0;text-decoration:underline}',
      '.tl-discount-form{display:flex;gap:8px;margin-top:10px}',
      '.tl-discount-input{flex:1;border:1px solid #e0e0e0;border-radius:4px;padding:9px 10px;font-size:13px;min-width:0}',
      '.tl-discount-apply{flex-shrink:0;background:#0f1117;color:#fff;border:none;border-radius:4px;padding:9px 14px;font-size:12px;font-weight:600;cursor:pointer}',
      '.tl-discount-apply:disabled{opacity:.5;cursor:default}',
      '.tl-discount-msg{font-size:12px;margin-top:8px}',
      '.tl-discount-msg.is-error{color:#e74c3c}',
      '.tl-discount-msg.is-ok{color:#1a7a3c}',
      '.tl-cf{padding:20px 24px;border-top:1px solid #e8e8e8;flex-shrink:0}',
      '.tl-total{display:flex;justify-content:space-between;font-size:16px;font-weight:700;margin-bottom:4px}',
      '.tl-installment{font-size:12px;color:#888;text-align:right;margin-bottom:14px}',
      '.tl-btn-checkout{display:block;width:100%;padding:15px;background:#0f1117;color:#fff;text-align:center;border-radius:6px;text-decoration:none;font-size:15px;font-weight:700;letter-spacing:.02em;margin-bottom:10px}',
      '.tl-btn-cart{display:block;width:100%;padding:12px;border:1.5px solid #d0d0d0;color:#333;text-align:center;border-radius:6px;text-decoration:none;font-size:13px}',
      '.tl-empty{text-align:center;color:#bbb;padding:48px 0;font-size:14px}'
    ].join('');
    document.head.appendChild(css);

    var el = document.createElement('div');
    el.id = 'tl-cart-overlay';
    el.innerHTML = [
      '<div id="tl-cart-panel">',
      '<div class="tl-ch"><span>Carrinho</span><button id="tl-cart-x" aria-label="Fechar">&times;</button></div>',
      '<div id="tl-ship"></div>',
      '<div class="tl-ci" id="tl-ci"></div>',
      '<div id="tl-upsell-zone"></div>',
      '<div class="tl-discount">',
      '<button type="button" class="tl-discount-toggle" id="tl-discount-toggle">+ Tem um cupom de desconto?</button>',
      '<div class="tl-discount-form" id="tl-discount-form" style="display:none">',
      '<input type="text" class="tl-discount-input" id="tl-discount-input" placeholder="Código do cupom">',
      '<button type="button" class="tl-discount-apply" id="tl-discount-apply">Aplicar</button>',
      '</div>',
      '<div class="tl-discount-msg" id="tl-discount-msg"></div>',
      '</div>',
      '<div class="tl-cf" id="tl-cf"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(el);

    document.getElementById('tl-cart-x').addEventListener('click', tlClose);
    el.addEventListener('click', function (e) { if (e.target === el) tlClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') tlClose(); });

    var discountToggle = document.getElementById('tl-discount-toggle');
    var discountForm    = document.getElementById('tl-discount-form');
    var discountInput   = document.getElementById('tl-discount-input');
    var discountApply   = document.getElementById('tl-discount-apply');
    var discountMsg     = document.getElementById('tl-discount-msg');

    discountToggle.addEventListener('click', function () {
      var isOpen = discountForm.style.display !== 'none';
      discountForm.style.display = isOpen ? 'none' : 'flex';
      if (!isOpen) discountInput.focus();
    });

    function applyDiscount() {
      var code = discountInput.value.trim();
      if (!code) return;
      discountApply.disabled = true;
      discountApply.textContent = '...';
      discountMsg.className = 'tl-discount-msg';
      discountMsg.textContent = '';

      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          tlRender(cart);
          var discounts = cart.cart_level_discount_applications || [];
          if (!discounts.length) {
            discountMsg.className = 'tl-discount-msg is-error';
            discountMsg.textContent = 'Cupom inválido ou expirado.';
          } else {
            discountInput.value = '';
          }
        })
        .catch(function () {
          discountMsg.className = 'tl-discount-msg is-error';
          discountMsg.textContent = 'Não foi possível aplicar. Tente novamente.';
        })
        .finally(function () {
          discountApply.disabled = false;
          discountApply.textContent = 'Aplicar';
        });
    }

    discountApply.addEventListener('click', applyDiscount);
    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
    });
  }

  function tlRender(cart) {
    var items     = cart.items || [];
    var total     = cart.total_price || 0;
    var remaining = Math.max(0, TL_FREE_SHIP - total);
    var pct       = Math.min(100, Math.round((total / TL_FREE_SHIP) * 100));

    var shipEl = document.getElementById('tl-ship');
    if (shipEl) {
      var shipMsg = remaining === 0
        ? '<strong>🎉 Você ganhou frete grátis!</strong>'
        : 'Faltam <strong>' + tlFmt(remaining) + '</strong> para ganhar frete grátis';
      shipEl.innerHTML = '<div class="tl-ship-text">' + shipMsg + '</div>'
        + '<div class="tl-ship-bar"><div class="tl-ship-fill" style="width:' + pct + '%"></div></div>';
    }

    var discountMsgEl = document.getElementById('tl-discount-msg');
    if (discountMsgEl) {
      var discounts = cart.cart_level_discount_applications || [];
      if (discounts.length) {
        discountMsgEl.className = 'tl-discount-msg is-ok';
        discountMsgEl.textContent = '✓ Cupom aplicado: ' + discounts.map(function (d) { return d.title; }).join(', ');
      } else if (discountMsgEl.className.indexOf('is-ok') === -1) {
        discountMsgEl.className = 'tl-discount-msg';
        discountMsgEl.textContent = '';
      }
    }

    var ciEl = document.getElementById('tl-ci');
    if (ciEl) {
      if (!items.length) {
        ciEl.innerHTML = '<p class="tl-empty">Seu carrinho está vazio.</p>';
      } else {
        ciEl.innerHTML = items.map(function (item) {
          var vLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="tl-ivar">' + item.variant_title + '</div>' : '';
          return '<div class="tl-item">'
            + '<img src="' + (item.image || '') + '" alt="" loading="lazy">'
            + '<div class="tl-iinfo">'
            + '<div class="tl-ititle">' + item.product_title + '</div>'
            + vLine
            + '<div class="tl-irow">'
            + '<div class="tl-qty">'
            + '<button class="tl-qbtn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>'
            + '<span>' + item.quantity + '</span>'
            + '<button class="tl-qbtn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
            + '</div>'
            + '<span class="tl-iprice">' + tlFmt(item.line_price) + '</span>'
            + '<button class="tl-remove" data-key="' + item.key + '" data-qty="0" aria-label="Remover">&times;</button>'
            + '</div></div></div>';
        }).join('');

        ciEl.querySelectorAll('.tl-qbtn, .tl-remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            tlChangeQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
          });
        });
      }
    }

    var upsellEl = document.getElementById('tl-upsell-zone');
    if (upsellEl) {
      var up = tlUpsellData();
      var inCart = up && items.some(function (i) { return i.variant_id === up.variantId; });
      if (up && up.variantId && !inCart) {
        upsellEl.innerHTML = '<div class="tl-upsell">'
          + '<div class="tl-upsell-lbl">Você também pode gostar</div>'
          + '<div class="tl-upsell-card">'
          + '<img src="' + up.image + '" alt="" loading="lazy">'
          + '<div class="tl-upsell-info">'
          + '<div class="tl-upsell-title">' + up.title + '</div>'
          + '<div class="tl-upsell-price">' + tlFmt(up.price) + '</div>'
          + '</div>'
          + '<button class="tl-upsell-btn" id="tl-upsell-add">+ Adicionar</button>'
          + '</div></div>';

        document.getElementById('tl-upsell-add').addEventListener('click', function () {
          var btn = document.getElementById('tl-upsell-add');
          if (btn) { btn.disabled = true; btn.textContent = 'Adicionando…'; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: up.variantId, quantity: 1 })
          }).then(function () {
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(tlRender);
          });
        });
      } else {
        upsellEl.innerHTML = '';
      }
    }

    var cfEl = document.getElementById('tl-cf');
    if (cfEl) {
      var installment = total > 0 ? tlFmt(Math.ceil(total / 10)) : null;
      cfEl.innerHTML = items.length
        ? '<div class="tl-total"><span>Total</span><span>' + tlFmt(total) + '</span></div>'
          + (installment ? '<div class="tl-installment">ou 10× de ' + installment + ' sem juros</div>' : '')
          + '<a href="/checkout" class="tl-btn-checkout">Finalizar Compra</a>'
          + '<a href="/cart" class="tl-btn-cart">Ver carrinho completo</a>'
        : '';
    }
  }

  function tlOpen() {
    var el = document.getElementById('tl-cart-overlay');
    if (!el) return;
    document.body.style.overflow = 'hidden';
    el.classList.add('is-open');
  }

  function tlClose() {
    var el = document.getElementById('tl-cart-overlay');
    if (el) el.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function tlChangeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(tlRender);
  }

  /* ── ATC Button ───────────────────────────────────────────── */
  var atcBtnAjax = document.getElementById('tirz-atc-btn');
  // Se o CTA for link de checkout externo, nao intercepta o clique
  if (atcBtnAjax && atcBtnAjax.tagName === 'BUTTON') {
    tlInitDrawer();

    atcBtnAjax.addEventListener('click', function () {
      var variantInput = document.getElementById(atcBtnAjax.dataset.variantInput);
      var variantId = variantInput && parseInt(variantInput.value, 10);
      if (!variantId) return;

      var originalLabel = atcBtnAjax.textContent;
      atcBtnAjax.disabled = true;
      atcBtnAjax.textContent = 'Adicionando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json().then(function () { return { ok: res.ok }; }); })
        .then(function (result) {
          if (!result.ok) { window.location.href = '/cart'; return; }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            tlRender(cart);
            tlOpen();
          });
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          atcBtnAjax.disabled = false;
          atcBtnAjax.textContent = originalLabel;
        });
    });
  }

  /* ── Sticky ATC (IntersectionObserver) ───────────────────── */
  const sentinel  = document.getElementById('tirz-atc-sentinel');
  const stickyBar = document.getElementById('tirz-sticky-atc');
  const stickyBtn = document.getElementById('tirz-sticky-btn');

  if (sentinel && stickyBar) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          } else {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { rootMargin: '-80px 0px 0px 0px' }
    );
    observer.observe(sentinel);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      const target = document.getElementById('tirz-purchase');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ── FAQ Accordion ────────────────────────────────────────── */
  const accordion = document.getElementById('tirz-faq');
  if (accordion) {
    accordion.querySelectorAll('.tirz-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        const body   = trigger.nextElementSibling;

        accordion.querySelectorAll('.tirz-accordion__trigger').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          const b = t.nextElementSibling;
          if (b) b.style.maxHeight = '0';
        });

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  /* ── Weight Loss Calculator ───────────────────────────────── */
  const calcWeight = document.getElementById('calc-weight');
  if (calcWeight) {
    var weightValEl  = document.getElementById('calc-weight-val');
    var target3El    = document.getElementById('calc-target-3');
    var target6El    = document.getElementById('calc-target-6');
    var loss3El      = document.getElementById('calc-loss-3');
    var loss6El      = document.getElementById('calc-loss-6');

    function updateSliderTrack(slider) {
      var min = parseFloat(slider.min) || 0;
      var max = parseFloat(slider.max) || 100;
      var val = parseFloat(slider.value) || 0;
      var pct = ((val - min) / (max - min)) * 100;
      slider.style.background = 'linear-gradient(to right, #6B9E7E 0%, #6B9E7E ' + pct + '%, rgba(255,255,255,0.2) ' + pct + '%, rgba(255,255,255,0.2) 100%)';
    }

    function computeCalc() {
      var w     = parseInt(calcWeight.value, 10);
      var loss3 = Math.round(w * 0.155);
      var loss6 = Math.round(w * 0.211);
      var tgt3  = w - loss3;
      var tgt6  = w - loss6;

      if (weightValEl) weightValEl.textContent = w;
      if (target3El)   target3El.textContent   = tgt3 + 'Kg';
      if (target6El)   target6El.textContent   = tgt6 + 'Kg';
      if (loss3El)     loss3El.textContent      = '-' + loss3 + 'KG';
      if (loss6El)     loss6El.textContent      = '-' + loss6 + 'KG';
      updateSliderTrack(calcWeight);
    }

    calcWeight.addEventListener('input', computeCalc);
    computeCalc();
  }

  /* ── Mechbar animation ──────────────────────────────────── */
  const mechbars = document.querySelectorAll('.tirz-mechbar__fill');
  if (mechbars.length && 'IntersectionObserver' in window) {
    const barObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-animated');
            barObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    mechbars.forEach(function (bar) { barObserver.observe(bar); });
  }

})();
